export const Header = (props) => {
    return <header>{props.children}</header>
}